import { Link, useLocation } from "react-router-dom";
import { scrollToSection } from "./motion.js";

/**
 * Enlace a una sección de la portada. En la portada baja suave hasta ella; en
 * el login o el alta lleva a la portada, que al montar se coloca en la sección
 * del hash.
 */
const SectionLink = ({ to, className, children }) => {
  const { pathname } = useLocation();

  return (
    <Link
      to={{ pathname: "/", hash: `#${to}` }}
      className={className}
      onClick={(event) => {
        if (pathname !== "/") return;
        event.preventDefault();
        scrollToSection(to);
      }}
    >
      {children}
    </Link>
  );
};

export default SectionLink;
